/**
 * Mega Menu Image Handler
 * Required HTML elements:
 * - .mega-menu__container: The main container for the mega menu
 * - #menuImage: The image element that will be updated on hover
 * - data-product-handle: Attribute on product links
 * - data-collection-handle: Attribute on collection links
 */

console.log('Mega menu script starting...');

document.addEventListener('DOMContentLoaded', function() {
  function validateRequiredElements() {
    const requirements = [
      {
        element: '.mega-menu__container',
        name: 'Mega Menu Container',
        found: !!document.querySelector('.mega-menu__container')
      },
      {
        element: '#menuImage',
        name: 'Menu Image',
        found: !!document.getElementById('menuImage')
      },
      {
        element: '[data-product-handle], [data-collection-handle]',
        name: 'Menu Links with Handles',
        found: !!document.querySelector('[data-product-handle], [data-collection-handle]')
      }
    ];

    const missingElements = requirements.filter(req => !req.found);
    
    if (missingElements.length > 0) {
      console.error('Mega Menu Initialization Failed:');
      console.error('Missing required elements:');
      missingElements.forEach(missing => {
        console.error(`- ${missing.name} (${missing.element})`);
      });
      return false;
    }

    console.log('All required elements found ✓');
    return true;
  }

  // Validate before initializing
  if (!validateRequiredElements()) {
    console.error('Mega menu initialization aborted due to missing elements');
    return;
  }

  const menuContainer = document.querySelector('.mega-menu__container');
  const menuImage = document.getElementById('menuImage');
  const imageCache = new Map();
  let defaultSrc = '';

  defaultSrc = menuImage.src;
  console.log('Default image src:', defaultSrc);

  async function getProductImage(handle, isCollection = false) {
    if (imageCache.has(handle)) {
      console.log('Returning cached image for:', handle);
      return imageCache.get(handle);
    }

    try {
      const endpoint = isCollection
        ? `/collections/${handle}/products.json?limit=1`
        : `/products/${handle}.json`;
      
      console.log('Fetching from endpoint:', endpoint);
      const response = await fetch(endpoint);
      const data = await response.json();

      let product;
      if (isCollection) {
        product = data.products[0];
      } else {
        product = data.product;
      }

      if (product && product.images && product.images.length > 1) {
        const imageUrl = product.images[1].src;
        imageCache.set(handle, imageUrl);
        return imageUrl;
      }
      
      return defaultSrc;
    } catch (error) {
      console.error('Error fetching image:', error);
      return defaultSrc;
    }
  }

  function preloadImage(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(url);
      img.onerror = reject;
      img.src = url;
    });
  }

  async function handleMenuOpen() {
    console.log('Menu opened, preloading images...');
    const links = menuContainer.querySelectorAll('[data-product-handle], [data-collection-handle]');
    
    for (const link of links) {
      const productHandle = link.dataset.productHandle;
      const collectionHandle = link.dataset.collectionHandle;
      
      if (productHandle || collectionHandle) {
        const handle = productHandle || collectionHandle;
        const isCollection = !!collectionHandle;
        
        try {
          const imageUrl = await getProductImage(handle, isCollection);
          await preloadImage(imageUrl);
          console.log('Preloaded image for:', handle);
        } catch (error) {
          console.error('Error preloading image:', error);
        }
      }
    }
  }

  menuContainer.addEventListener('mouseenter', handleMenuOpen);

  const menuLinks = menuContainer.querySelectorAll('[data-product-handle], [data-collection-handle]');
  menuLinks.forEach(link => {
    link.addEventListener('mouseenter', async function() {
      const productHandle = this.dataset.productHandle;
      const collectionHandle = this.dataset.collectionHandle;
      
      if (productHandle || collectionHandle) {
        const handle = productHandle || collectionHandle;
        const isCollection = !!collectionHandle;
        
        try {
          const imageUrl = await getProductImage(handle, isCollection);
          menuImage.src = imageUrl;
        } catch (error) {
          console.error('Error updating image:', error);
          menuImage.src = defaultSrc;
        }
      }
    });
  });

  menuContainer.addEventListener('mouseleave', function() {
    menuImage.src = defaultSrc;
  });
});